import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Paper, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, LinearProgress, TextField } from "@mui/material";
import { Formik, Form, Field } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { getPartrequest } from "../../reduxStore/entities/partrequestDetails";
import { createNewOffer } from "../../reduxStore/entities/offers";
import Layout from "../../core/Layout";
import { useIdParam } from "../../hooks/useIdParam";

// Define styles using `sx` prop or styled API
const useStyles = () => ({
    createOfferForm: {
        padding: "20px",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    formField: {
        margin: "20px",
    },
});

// Define table column configuration
const columns = [
    { id: "naziv", label: "Naziv", minWidth: 100 },
    { id: "vrednost", label: "Vrednost", minWidth: 100, align: "center" },
];

const columnsOffer = [
    { id: "part_offer_id", label: "ID", minWidth: 100 },
    { id: "title", label: "Title", minWidth: 100 },
    { id: "description", label: "Description", minWidth: 170 },
    { id: "type", label: "Type", minWidth: 170 },
    { id: "price", label: "Price", minWidth: 170 },
];

// Custom TableCell and TableRow styling
const StyledTableCell = (props) => (
    <TableCell {...props} sx={{ backgroundColor: 'primary.main', color: 'white' }} />
);

const StyledTableRow = (props) => (
    <TableRow {...props} sx={{ "&:nth-of-type(odd)": { backgroundColor: 'action.hover' } }} />
);

// Data creation functions
function createData(naziv, vrednost) {
    return { naziv, vrednost };
}

function createDataOffer(part_offer_id, title, description, type, price) {
    return { part_offer_id, title, description, type, price };
}

export default function RequestCreateOffer(props) {
    let navigate = useNavigate();
    const id = useIdParam();

    const partrequest = useSelector((state) => state.partrequestDetails.partrequest);
    const classes = useStyles();
    const dispatch = useDispatch();
    const [rows, setRows] = React.useState([]);
    const [rowsOffers, setRowsOffers] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const dataLoaded = useSelector((state) => state.partrequestDetails.dataLoaded);

    const offers = partrequest?.PartOffers;

    const populateTable = (partrequest) => {
        const rows = [];
        rows.push(createData("ID", partrequest.part_request_id));
        rows.push(createData("Naslov", partrequest.title));
        rows.push(createData("Opis", partrequest.description));
        rows.push(createData("Marka", partrequest.Make.name));
        rows.push(createData("Model", partrequest.Model.name));
        rows.push(createData("Generacija", partrequest.Generation.name));
        rows.push(createData("Motor", partrequest.Motor.name));
        rows.push(createData("Stanje", partrequest.state));
        rows.push(createData("Podnet", partrequest.createdAt));
        return rows;
    };

    const handleTableLoad = (offers) => {
        const preparedData = offers.map((offer) => {
            return createDataOffer(offer.part_offer_id, offer.title, offer.description, offer.type, offer.price);
        });
        return preparedData;
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    useEffect(() => {
        const doasync = async () => {
            await dispatch(getPartrequest(id));
        };
        doasync();
    }, [dispatch]);

    useEffect(() => {
        if (dataLoaded) {
            setRows(populateTable(partrequest));
            setRowsOffers(handleTableLoad(offers));
        }
    }, [partrequest, dataLoaded]);

    const handleClick = (id) => {
        navigate("/admin/offers/" + id);
    };

    return (
        <Layout>
            <div>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Paper sx={{ p: 2 }}>
                            <TableContainer>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            {columns.map((column) => (
                                                <StyledTableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                                    {column.label}
                                                </StyledTableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                                            <StyledTableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                                {columns.map((column) => {
                                                    const value = row[column.id];
                                                    return (
                                                        <StyledTableCell key={column.id} align={column.align}>
                                                            {value}
                                                        </StyledTableCell>
                                                    );
                                                })}
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </Grid>
                </Grid>
            </div>

            <div>Slanje ponude:</div>
            <Formik
                initialValues={{
                    title: "novi deo",
                    description: "novi deo iz radnje",
                    price: 0,
                    part_request_id: id,
                }}
                validate={(values) => {
                    const errors = {};
                    if (!values.description) {
                        errors.description = "Morate uneti opis";
                    } else if (!values.price) {
                        errors.price = "Morate uneti cenu";
                    }
                    return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                        setSubmitting(false);
                        dispatch(createNewOffer(values));
                    }, 500);
                }}
            >
                {({ submitForm, isSubmitting }) => (
                    <Grid item xs={12}>
                        <Paper sx={{ p: 2 }}>
                            <Form>
                                <Field className={classes.formField} component={TextField} name="description" label="Opis ponude" multiline />
                                <Field className={classes.formField} component={TextField} type="number" label="Price" name="price" />
                                <Button className={classes.formField} variant="contained" color="primary" disabled={isSubmitting} onClick={submitForm}>
                                    Submit
                                </Button>
                                {isSubmitting && <LinearProgress />}
                            </Form>
                        </Paper>
                    </Grid>
                )}
            </Formik>

            <div>Primljene Ponude:</div>
            <div>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Paper sx={{ p: 2 }}>
                            <TableContainer>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            {columnsOffer.map((column) => (
                                                <StyledTableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                                    {column.label}
                                                </StyledTableCell>
                                            ))}
                                            <StyledTableCell> </StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rowsOffers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                                            <StyledTableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                                {columnsOffer.map((column) => {
                                                    const value = row[column.id];
                                                    return (
                                                        <StyledTableCell key={column.id} align={column.align}>
                                                            {value}
                                                        </StyledTableCell>
                                                    );
                                                })}
                                                <StyledTableCell>
                                                    <Button variant="contained" onClick={() => handleClick(row.part_offer_id)}>
                                                        Details
                                                    </Button>
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </Layout>
    );
}
